import { apiProxyRequest } from "Api/apiProxyRequest";

import type {
  BillingAccountMappingWithLinks,
  BillingAccountUpdatableFields
} from "../types";

export const updateBillingAccountRequest = (
  billingAccountId: string,
  payload: BillingAccountUpdatableFields
) =>
  apiProxyRequest<BillingAccountMappingWithLinks>(
    `/billing/accounts/${billingAccountId}`,
    "PATCH",
    payload
  );
